// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"54785d5c","239":"ea0978a2","453":"ff9ff422","455":"9fe7eed3"}[chunkId] + ".chunk.js";
};